import styled from 'styled-components';
import { baseSelectionStyle } from '../tokens/selection';
const Strong = styled.span`
  font-weight: 600;
  ${baseSelectionStyle}
`;
export default Strong;